
import {
  Obra
} from '../index';


export class ObraRegistroAtraso {
  "ObraId";
  "tempoEmHoras";
  "abonadoTEXTO";
  "motivo";
  "descricaoDoMotivoDoAtraso";
  "responsabilidade";
  "subOfensores";
  "dataDoReport";
  "id";
  Obra;
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ObraRegistroAtraso`.
   */
  static getModelName() {
    return "ObraRegistroAtraso";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ObraRegistroAtraso for dynamic purposes.
  **/
  static factory(data) {
    return new ObraRegistroAtraso(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'ObraRegistroAtraso',
      plural: 'ObraRegistroAtrasos',
      path: 'ObraRegistroAtrasos',
      properties: {
        "ObraId": {
          name: 'ObraId',
          type: 'string'
        },
        "tempoEmHoras": {
          name: 'tempoEmHoras',
          type: 'string'
        },
        "abonadoTEXTO": {
          name: 'abonadoTEXTO',
          type: 'string'
        },
        "motivo": {
          name: 'motivo',
          type: 'string'
        },
        "descricaoDoMotivoDoAtraso": {
          name: 'descricaoDoMotivoDoAtraso',
          type: 'string'
        },
        "responsabilidade": {
          name: 'responsabilidade',
          type: 'string'
        },
        "subOfensores": {
          name: 'subOfensores',
          type: 'string'
        },
        "dataDoReport": {
          name: 'dataDoReport',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        Obra: {
          name: 'Obra',
          type: 'Obra',
          model: 'Obra'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ObraRegistroAtraso.js